var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "currentcolor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,8V7.38739a1,1,0,0,0-1.31622-.94867l-1.55335.51782-.716-2.506A1.99994,1.99994,0,0,0,17.49139,3H6.50861a1.99994,1.99994,0,0,0-1.923,1.45056l-.716,2.506L2.31622,6.43872A1,1,0,0,0,1,7.38739V8A1,1,0,0,0,2,9H3.28571L3,10H2a1,1,0,0,0-1,1v7H2v2a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1V18H17v2a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V18h1V11a1,1,0,0,0-1-1H21l-.28571-1H22A1,1,0,0,0,23,8ZM5.81061,4.75745A1,1,0,0,1,6.78076,4H17.21924a1,1,0,0,1,.97015.75745L19.5,10H4.5ZM8,15a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H7a1,1,0,0,1,1,1Zm13,0a1,1,0,0,1-1,1H17a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1Z",
    transform: "translate(-1 -3)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.17936ac1.svg";
export { ForwardRef as ReactComponent };